export default __webpack_public_path__ + "static/media/icons8-refresh.33d978f5.svg";